(() => {
  const pendingCalls = [];
  const observedElements = new WeakSet();
  let drawerIsOpen = false;
  let drawerOpenedAt = 0;
  let checkoutClicked = false;

  const sendToClarity = (command, ...args) => {
    if (typeof window.clarity === 'function') {
      window.clarity(command, ...args);
      return;
    }
    pendingCalls.push([command, ...args]);
  };

  const trackEvent = name => sendToClarity('event', name);
  const setTag = (key, value) => sendToClarity('set', key, String(value));

  const flushPendingCalls = () => {
    if (typeof window.clarity !== 'function') return false;
    while (pendingCalls.length) window.clarity(...pendingCalls.shift());
    return true;
  };

  let clarityWaitAttempts = 0;
  const clarityWaitTimer = window.setInterval(() => {
    clarityWaitAttempts += 1;
    if (flushPendingCalls() || clarityWaitAttempts >= 40) {
      window.clearInterval(clarityWaitTimer);
    }
  }, 500);

  const isProductPage = document.body.classList.contains('template--product');
  setTag('journey_tracking_version', 'v1_2026_08_17');

  if (isProductPage) {
    const productHandle = window.location.pathname.split('/products/')[1]?.split(/[?#/]/)[0];
    setTag('journey_page_type', 'product');
    if (productHandle) setTag('journey_product_handle', productHandle);
    trackEvent('journey_product_view');
  }

  const visibilityObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;

        const trackingName = entry.target.dataset.clarityTrack;
        if (trackingName === 'assurance-panel' && isProductPage) {
          trackEvent('journey_shipping_info_view');
        }
        if (trackingName === 'drawer-shipping' && drawerIsOpen) {
          trackEvent('journey_drawer_shipping_seen');
        }
        visibilityObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.5 }
  );

  const observeJourneyElements = () => {
    const selectors = isProductPage
      ? ['#MainContent [data-clarity-track="assurance-panel"]', '[data-clarity-track="drawer-shipping"]']
      : ['[data-clarity-track="drawer-shipping"]'];

    document.querySelectorAll(selectors.join(',')).forEach(element => {
      if (observedElements.has(element)) return;
      observedElements.add(element);
      visibilityObserver.observe(element);
    });
  };

  const drawerCloseTimeEvent = elapsedSeconds => {
    if (elapsedSeconds < 5) return 'journey_drawer_close_under_5s';
    if (elapsedSeconds < 15) return 'journey_drawer_close_5_15s';
    return 'journey_drawer_close_over_15s';
  };

  const updateDrawerState = () => {
    const drawer = document.querySelector('[data-clarity-track="cart-drawer"]');
    const currentlyOpen = Boolean(drawer?.classList.contains('is-visible'));

    if (currentlyOpen && !drawerIsOpen) {
      drawerIsOpen = true;
      drawerOpenedAt = Date.now();
      checkoutClicked = false;
      trackEvent('journey_cart_drawer_open');
      observeJourneyElements();
      return;
    }

    if (!currentlyOpen && drawerIsOpen) {
      const elapsedSeconds = Math.max(0, (Date.now() - drawerOpenedAt) / 1000);
      drawerIsOpen = false;
      trackEvent('journey_cart_drawer_close');
      if (!checkoutClicked) {
        trackEvent('journey_drawer_close_without_checkout');
        trackEvent(drawerCloseTimeEvent(elapsedSeconds));
      }
    }
  };

  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-clarity-track="size-guide"]')) {
      trackEvent('journey_size_guide_open');
    }

    const addToCartButton = target.closest('[data-clarity-track="add-to-cart"]');
    if (addToCartButton && !addToCartButton.disabled) {
      trackEvent('journey_add_to_cart_click');
    }

    if (target.closest('[data-clarity-track="checkout"]')) {
      checkoutClicked = true;
      trackEvent('journey_checkout_click');
    }
  });

  document.addEventListener('change', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest('product-variant-selects')) return;
    if (!target.matches('input[name*="options"], select[name*="options"]')) return;
    trackEvent('journey_size_selected');
  });

  const pageObserver = new MutationObserver(() => {
    observeJourneyElements();
    updateDrawerState();
  });

  observeJourneyElements();
  updateDrawerState();
  pageObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();
